import { render, staticRenderFns } from "./menuTabButton.vue?vue&type=template&id=5b046681"
import script from "./menuTabButton.vue?vue&type=script&lang=js"
export * from "./menuTabButton.vue?vue&type=script&lang=js"
import style0 from "./menuTabButton.vue?vue&type=style&index=0&id=5b046681&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports